export default __webpack_public_path__ + "static/media/portfolio-176.701f4774.jpg";